<template>
  <div class="shadow-sm tw-rounded-lg" style="height: 280px; width: 100%">
    <div class="tw-flex tw-h-full">
      <div class="tw-w-60 tw-flex-none">
        <div
          class="tw-px-6 tw-py-4 tw-flex tw-flex-col no-select tw-bg-gray-50 tw-rounded-lg"
          style="width: 100%; height: 100%"
        >
          <div
            class="tw-flex tw-items-center tw-cursor-pointer"
            @click="handleAllSupport"
          >
            <div class="tw-flex tw-items-center" style="color: #333">
              <img class="tw-w-6 tw-h-6" src="/icon-kf.png" alt />
              <span class="tw-ml-2 tw-text-lg tw-font-medium">{{
                $t("支持与服务")
              }}</span>
            </div>
          </div>
          <div class="tw-flex tw-flex-col tw-mt-5">
            <div class="tw-flex-1">
              <span class="tw-text-sm" style="color: #666">{{
                $t("支持与服务介绍")
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="tw-flex-1 tw-flex tw-pt-4 tw-pr-4 tw-pl-4">
        <b-row class="tw-w-full">
          <b-col v-for="(item, index) in supports" cols="4" xl="3" :key="index">
            <SelectItem :item="item" @onSelect="handleToDetail" />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import SelectItem from "./components/SelectItem.vue";
import authMixin from "@/mixins/authMixin";
export default {
  name: "SupportMenu",
  components: {
    SelectItem,
  },
  data() {
    return {
      navItems: [
        {
          id: 1,
          name: this.$t("支持与服务"),
        },
      ],
      activeId: 1,
      supports: [
        {
          id: 1,
          icon: "/icon-wtfk.png",
          name: this.$t("问题反馈"),
          intro: this.$t("提交问题，快速响应，助您无忧使用"),
        },
        {
          id: 2,
          icon: "/icon-zxkf.png",
          name: this.$t("在线客服"),
          intro: this.$t("实时咨询，解答疑问，助您快速上手"),
        },
      ],
    };
  },
  mounted() {},
  mixins: [authMixin],
  methods: {
    handleAllSupport() {
      this.$router.push("/supportAndServices/Feedback");
      this.$emit("handleToDetail", null);
    },
    handleToDetail(item) {
      if (item.id === 1) {
        this.$router.push("/supportAndServices/Feedback");
      } else {
        // 检查用户是否登录,使用封装的方法
        // if (!this.checkLoginAndRedirect()) return

        window.kuaizhichat();
      }
      this.$emit("handleToDetail", null);
    },
  },
};
</script>
<style lang="scss" scoped>
.menu-item:hover {
  color: #4077f8;

  //.menu-title {
  //  padding-bottom: 4px;
  //  border-bottom: 2px solid #4077F8;
  //}
}

.menu-title-active {
  color: #4077f8;
  padding-bottom: 4px;
  border-bottom: 2px solid #4077f8;
}

.item-c:hover {
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);

  .item-title {
    color: #4077f8 !important;
  }
}
</style>
